import { BottomSheet, Text, Title, type UseModalState } from "@clipboard-health/ui-components";
import { DialogContent, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

export type CreditExplanationVariant = "before-ec-window" | "after-shift-start" | "no-benefit";

interface CancellationCreditExplanationModalProps {
  readonly modalState: UseModalState;
  readonly variant: CreditExplanationVariant;
}

export function CancellationCreditExplanationModal(
  props: CancellationCreditExplanationModalProps
): JSX.Element {
  const { modalState, variant } = props;

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical">
          <Button
            fullWidth
            size="large"
            variant="contained"
            onClick={() => {
              modalState.closeModal();
            }}
          >
            Close
          </Button>
        </DialogFooter>
      }
    >
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          paddingTop: 9,
        }}
      >
        <Stack spacing={4} sx={{ paddingX: 4 }}>
          <Title variant="h4" component="h4" sx={{ textAlign: "center" }}>
            Why can&apos;t I use my credit?
          </Title>

          {variant === "before-ec-window" && (
            <Text variant="body1" align="center">
              You can&apos;t use your same-day cancellation Emergency Credit because this shift
              starts in more than 24 hours. You&apos;re already saving points by cancelling earlier!
            </Text>
          )}

          {variant === "after-shift-start" && (
            <Stack spacing={2}>
              <Text variant="body1" align="center">
                You can&apos;t use your same-day cancellation Emergency Credit because this shift
                has already started.
              </Text>
              <Text variant="body1" align="center" color="error">
                Cancelling now would be considered a No Show, and lead to account Restriction.
              </Text>
            </Stack>
          )}

          {variant === "no-benefit" && (
            <Text variant="body1" align="center">
              You can&apos;t use your same-day cancellation Emergency Credit because using it would
              not lower this penalty.
            </Text>
          )}
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
